<template>
  <component :is="userData === undefined ? 'div' : 'b-card'">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        No se encontró la información.
      </h4>
      <div class="alert-body">
        Usuario no encontrado. Selecciona otro usuario
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          de la lista.
        </b-link>
      </div>
    </b-alert>
    <b-tabs
      v-if="userData"
      pills
    >

      <!-- Tab: Account -->
      <b-tab v-if="userRol.id === 3">
        <template #title>
          <feather-icon
            icon="LockIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Cuenta</span>
        </template>
        <editar-usuario-cuentas
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <!-- Tab: Persona -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Persona</span>
        </template>
        <editar-usuario-persona
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon
            icon="BookOpenIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Profesión</span>
        </template>
        <editar-usuario-profesion
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink,
} from 'bootstrap-vue'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import EditarUsuarioCuentas from './components/editar-usuario/EditarUsuarioCuentas.vue'
import EditarUsuarioPersona from './components/editar-usuario/EditarUsuarioPersona.vue'
import EditarUsuarioProfesion from './components/editar-usuario/EditarUsuarioProfesion.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,

    EditarUsuarioCuentas,
    EditarUsuarioPersona,
    EditarUsuarioProfesion,
  },
  setup() {
    const userData = ref(null)
    const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
    const USER_APP_STORE_MODULE_NAME = 'app-user'
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('usuario/fetchUser', { d: router.currentRoute.params.id })
      .then(response => {
        userData.value = response
      })
      .catch(() => {
        userData.value = undefined
      })
    return {
      userData,
      userRol,
    }
  },
}
</script>

<style>

</style>
